import { CommonModule } from '@angular/common';
import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, HostListener, Input, NgModule, ViewChild } from '@angular/core';
import { filter } from 'rxjs/operators';
import { BalloonPopupOriginDirective } from './balloon-popup-origin.directive';
import { BalloonPopupService } from './balloon-popup.service';

@Component({
  selector: 'lp2-balloon-popup',
  template: `
    <div [ngClass]="['balloon', 'balloon-' + direction]" #balloon><ng-content></ng-content></div>
    <div class="balloon-border" #border></div>
  `,
  styleUrls: ['./balloon-popup.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BalloonPopupComponent implements AfterViewInit {
  @Input() offsetY: number = 0;
  @Input() offsetX: number = 0;
  @Input() direction: 'left' | 'right' = 'left';

  @ViewChild('border') border: ElementRef;
  @ViewChild('balloon') balloon: ElementRef;

  constructor(
    private readonly elRef: ElementRef,
    private readonly balloonPopupService: BalloonPopupService,
  ) {}

  ngAfterViewInit() {
    this.balloonPopupService.state$.pipe(filter((el) => el !== null)).subscribe(() => {
      setTimeout(() => this.setPosition(), 500);
    });

    this.setBorderProperties();
  }

  @HostListener('window:resize')
  private setPosition() {
    if (this.balloonPopupService.state) {
      const attachedRect = this.balloonPopupService.state.getBoundingClientRect();
      const elRect = this.elRef.nativeElement.getBoundingClientRect();
      let leftPosition = attachedRect.right;
      if (this.direction === 'left') {
        leftPosition -= elRect.width + attachedRect.width;
      }
      this.elRef.nativeElement.style.top = `${attachedRect.top + this.offsetY}px`;
      this.elRef.nativeElement.style.left = `${leftPosition + this.offsetX}px`;
    }
  }

  private setBorderProperties() {
    const offset = 2;
    const position = (offset / 2) * -1;

    this.border.nativeElement.style.setProperty('--width', `${this.balloon.nativeElement.offsetWidth + offset}px`);
    this.border.nativeElement.style.setProperty('--height', `${this.balloon.nativeElement.offsetHeight + offset}px`);
    this.border.nativeElement.style.setProperty('--position', `${position}px`);
  }
}

@NgModule({
  imports: [CommonModule],
  exports: [BalloonPopupComponent, BalloonPopupOriginDirective],
  declarations: [BalloonPopupComponent, BalloonPopupOriginDirective],
  providers: [BalloonPopupService],
})
export class BalloonPopupModule { }




// WEBPACK FOOTER //
// ./ts/app/shared/balloon-popup/balloon-popup.component.ts